import { sendDataEvent } from "//gunner.com/cdn/shop/t/611/assets/data-capture_send-event.js?v=89369398181597458251717752096";

const g1KennelQrCodeModal = document.querySelector('.g1-kennel-qr-code-modal-background');

// showG1KennelQrCodeModal()
const showG1KennelQrCodeModal = () => {

  const eventData = {
    event_name: 'modal_viewed',
    event_element_id: 'zFzWhRojOgWy5z8Du6iUSxbijM4uUfJf'
  };
  sendDataEvent(eventData);

  // Show the g1KennelQrCodeModal.
  g1KennelQrCodeModal.style.zIndex = '99999999';
  g1KennelQrCodeModal.classList.add('visible');
  document.querySelector('body').classList.add('no-scrolling');
  document.querySelector('body').classList.add('modal-opened');
};


// hideG1KennelQrCodeModal()
const hideG1KennelQrCodeModal = () => {

  // Hide the g1KennelQrCodeModal.
  document.querySelector('body').classList.remove('no-scrolling');
  document.querySelector('body').classList.remove('modal-opened');

  setTimeout(function () {
    g1KennelQrCodeModal.classList.remove('visible');
    setTimeout(() => g1KennelQrCodeModal.style.zIndex = null, 100);
  }, 100);
};


// handleG1KennelQrCodeModalClickOutside()
// If the g1KennelQrCodeModal is currently visible (the click is not within the g1KennelQrCodeModal || is the g1KennelQrCodeModal close button || is the g1KennelQrCodeModal open button) - hide the g1KennelQrCodeModal.
const handleG1KennelQrCodeModalClickOutside = (e) => {
  if (g1KennelQrCodeModal && g1KennelQrCodeModal.classList.contains('visible') && ((!g1KennelQrCodeModal.querySelector('.g1-kennel-qr-code-modal-content').contains(e.target) && !e.target.classList.contains('g1-kennel-qr-code-modal-open') && !e.target.closest('.g1-kennel-qr-code-modal-open')) || e.target === g1KennelQrCodeModal.querySelector('.g1-kennel-qr-code-modal-close'))) {
    hideG1KennelQrCodeModal();

    const eventData = {
      event_name: 'click_outside_close',
      event_element_id: 'zFzWhRojOgWy5z8Du6iUSxbijM4uUfJf'
    };
    sendDataEvent(eventData);
  }
}

document.addEventListener('click', (e) => handleG1KennelQrCodeModalClickOutside(e));
// document.addEventListener('touchstart', (e) => {
//     e.preventDefault();
//     handleG1KennelQrCodeModalClickOutside(e);
// });

document.querySelectorAll('.g1-kennel-qr-code-modal-open').forEach(modalOpen => modalOpen.addEventListener('click', () => showG1KennelQrCodeModal()));